<div class="content">
  <!-- app bar -->
  <app-app-bar></app-app-bar>
  <!-- content -->
  <router-outlet> </router-outlet>
</div>
